import { ELicenseAction, FetchLicenseAction } from "../actions/LicenseAction";
import { RootState } from "./RootReducer";

type State = {
  isAllowToRun?: boolean;
};

const initialState: State = {
  isAllowToRun: undefined,
};

export function licenseReducer(
  state = initialState,
  action: FetchLicenseAction
): State {
  switch (action.type) {
    case ELicenseAction.FETCH_LICENSE_INFO:
      return { ...state, isAllowToRun: action.isAllowToRun };
    case ELicenseAction.UPDATE_LICENSE_INFO:
      return { ...state, isAllowToRun: action.isAllowToRun };
    default:
      return state;
  }
}

export const selectIsAllowToRun = (state: RootState): boolean | undefined =>
  state.licenseStore.isAllowToRun;
